import { useSyncExternalStore } from 'react';

// Tailwind's `md` breakpoint. Below it we render the mobile pages; at or above it the
// desktop grid takes over. Keep this string in sync with any `md:` classes that gate the
// same split in App.tsx.
const MOBILE_QUERY = '(max-width: 767px)';

function subscribe(onChange: () => void): () => void {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};
  const mql = window.matchMedia(MOBILE_QUERY);
  // Safari < 14 only has the deprecated add/removeListener pair; addEventListener is
  // available everywhere we support, and rotation fires `change` just like a resize.
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
}

function getSnapshot(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(MOBILE_QUERY).matches;
}

function getServerSnapshot(): boolean {
  return false;
}

/**
 * True when the viewport is narrower than Tailwind's `md` breakpoint (768px).
 *
 * Re-evaluates on resize and device rotation, so a phone turned landscape or a tablet
 * past 768px gets the desktop view at the same URL with no reload. SSR-safe: defaults to
 * `false` (desktop) when there is no `window`.
 *
 * @example
 * const isMobile = useIsMobile();
 * return isMobile ? <ScheduleMobilePage /> : <ScheduleDesktopPage />;
 */
export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
